import React, { ReactElement } from 'react'
import { ICheckboxInput } from '../../interfaces/FormFields'
import { ALERT_MESSAGES } from '../../enums/common'

const Checkbox = ({
  id,
  name,
  label,
  register,
  error,
  onChange,
  checked,
  disabled,
  labelClassName,
  className = 'mb25',
}: ICheckboxInput): ReactElement => {
  return (
    <div className={className}>
      <label className="inputLabel inputCheckboxWrapper" htmlFor={id}>
        <div className="inputCheckboxContent">
          <input
            id={id}
            name={name}
            type="checkbox"
            className={`inputCheckbox ${error ? 'errorHighlight' : ''} `}
            ref={register}
            defaultChecked={checked}
            onChange={onChange}
            disabled={disabled}
          />
          <div className="inputCheckboxMask" />
        </div>
        <span
          className={`${labelClassName} ${
            disabled ? 'textPrimaryDark notAllowed' : 'pointer'
          }`}
        >
          {label}
        </span>
      </label>
      {error && (
        <p className="errorError mt05">
          {error.message || ALERT_MESSAGES.mandatory.message}
        </p>
      )}
    </div>
  )
}

export default Checkbox
